import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";

import Logo from "../Images/CG LOGO white.png";
import { Close, Menu } from "@mui/icons-material";

const drawerWidth = "100%";

const navItems = [
  { label: "Home", path: "/" },
  { label: "Gallery", path: "/Gallery" },
  { label: "Blog", path: "/Blog" },
  { label: "About", path: "/About" },
  { label: "Contact", path: "/Contact" },
];

export default function DrawerAppBar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box
      onClick={handleDrawerToggle}
      sx={{
        "& .css-b7dj7n-MuiList-root": {
          margin: 0,
          padding: 0,
        },
      }}
    >
      <List>
        {navItems.map((item) => (
          <ListItem
            key={item.label}
            disablePadding
            style={{
              border: "0.1px dotted lightgray",
              padding: "5px 18px",
            }}
          >
            <Link
              to={item.path}
              style={{ textDecoration: "none", width: "100%" }}
            >
              <ListItemText
                primary={item.label}
                sx={{
                  color: "gray",
                  position: "relative",
                  transition: "0.3s",
                  "&:hover": {
                    color: "red",
                  },
                }}
              />
            </Link>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        component="nav"
        sx={{
          background:
            location.pathname === "/"
              ? "rgba(0, 0, 0, 0)"
              : "linear-gradient(to top, rgba(0, 0, 0, 0) 0%, black 80%)",
          boxShadow: "none",
        }}
        position="absolute"
      >
        <Toolbar style={{ display: "flex", justifyContent: "space-between" }}>
          
          {/* ✅ Clickable Logo */}
          <Link to="/">
            <img
              src={Logo}
              alt="Central Group"
              width={"100px"}
              style={{ cursor: "pointer" }}
            />
          </Link>

          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ display: { sm: "none" } }}
          >
            {!mobileOpen ? <Menu /> : <Close />}
          </IconButton>

          {/* ✅ Desktop Menu */}
          <Box sx={{ display: { xs: "none", sm: "block" }, mr: 2 }}>
            {navItems.map((item) => (
              <Button
                key={item.label}
                component={Link}
                to={item.path}
                sx={{
                  textTransform: "capitalize",
                  fontSize: "15px",
                  color: "#fff",
                  fontFamily: "Poppins, serif",
                  position: "relative",
                  mx: 1,
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    width: "0%",
                    height: "2px",
                    bottom: 0,
                    left: 0,
                    backgroundColor: "red",
                    transition: "0.3s ease",
                  },
                  "&:hover::after": {
                    width: "100%",
                  },
                }}
              >
                {item.label}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </AppBar>

      {/* ✅ Mobile Drawer */}
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          anchor="top"
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              mt: "150px",
            },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </Box>
  );
}